import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';
import { useCAForCard } from '@/microfrontends/listing/shared/hooks/card/useCAForCard';

import { CardAddressBlock } from './components/CardAddressBlock';

export function CardAddressBlockContainer(): JSX.Element {
  const {
    geo: { address },
  } = useCardOfferDataContext();

  const caForCard = useCAForCard();

  return (
    <CardAddressBlock
      address={address}
      track={(): void => caForCard({ action: 'click_sopr', category: 'Listing', label: 'to_listing_address' })}
    />
  );
}
